import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
let Clip = class Clip extends Vue {
  constructor() {
    super(...arguments);
    this.clipToVisualize = 0;
  }
  get clipCountLabels() {
    return [this.$t("message.NO").toString(), "1", "2", "3", "4"];
  }
  get numberOfClips() {
    return this.$store.state.configurator.numberOfClips || 0;
  }
  get clipLenses() {
    return this.$store.getters["configurator/lenti/clipLenses"] || [];
  }
  get selectedClips() {
    return this.$store.state.configurator.lentiSoleClip || [];
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  get correspondingClip() {
    return this.$store.getters["configurator/correspondingClip"];
  }
  get correspondingFrontaleWithClip() {
    return this.$store.getters["configurator/correspondingFrontalWithClip"];
  }
  get correspondingFrontaleWithoutClip() {
    return this.$store.getters["configurator/correspondingFrontalWithoutClip"];
  }
  get allClips() {
    var _this$$store$state$co;
    return ((_this$$store$state$co = this.$store.state.configurator) === null || _this$$store$state$co === void 0 || (_this$$store$state$co = _this$$store$state$co.frontali) === null || _this$$store$state$co === void 0 ? void 0 : _this$$store$state$co.clips) || [];
  }
  mounted() {
    this.syncClipStateWithSelection();
    if (this.numberOfClips > 0 && this.selectedClips.length > 0) {
      this.clipToVisualize = Math.min(this.numberOfClips, this.selectedClips.length);
      this.setClipLensToVisualize();
    }
  }
  onNumberOfClipsChanged(newVal) {
    this.syncClipStateWithSelection();
    if (newVal <= 0) {
      this.$store.commit("configurator/setClipLensesModels", []);
      this.$store.commit("configurator/setLenteClipToVisualize", null);
      this.clipToVisualize = 0;
      return;
    }
    if (this.selectedClips.length > newVal) {
      const clipped = this.selectedClips.slice(0, newVal);
      this.$store.commit("configurator/setClipLensesModels", clipped);
    }
    if (this.clipToVisualize > newVal) {
      this.clipToVisualize = Math.min(newVal, this.selectedClips.length);
    }
    this.setClipLensToVisualize();
  }
  onFrontaleChanged() {
    this.syncClipStateWithSelection();
  }
  onCorrespondingClipChanged() {
    this.syncClipStateWithSelection();
  }
  syncClipStateWithSelection() {
    if (this.numberOfClips > 0) {
      if (this.correspondingFrontaleWithClip) {
        this.setFrontalIfDifferent(this.correspondingFrontaleWithClip);
      }
      const resolvedClip = this.resolveClipForCurrentFrontale();
      if (resolvedClip) {
        this.setClipIfDifferent(resolvedClip);
      }
      return;
    }
    if (this.correspondingFrontaleWithoutClip) {
      this.setFrontalIfDifferent(this.correspondingFrontaleWithoutClip);
    }
    this.setClipIfDifferent(null);
  }
  setFrontalIfDifferent(front) {
    var _this$$store$state$co2;
    const currentCode = ((_this$$store$state$co2 = this.$store.state.configurator) === null || _this$$store$state$co2 === void 0 || (_this$$store$state$co2 = _this$$store$state$co2.frontale) === null || _this$$store$state$co2 === void 0 ? void 0 : _this$$store$state$co2.ItemCode) || "";
    const nextCode = (front === null || front === void 0 ? void 0 : front.ItemCode) || "";
    if (!nextCode || currentCode === nextCode) return;
    this.$store.commit("configurator/setFrontal", front);
  }
  setClipIfDifferent(clip) {
    var _this$$store$state$co3;
    const currentCode = ((_this$$store$state$co3 = this.$store.state.configurator) === null || _this$$store$state$co3 === void 0 || (_this$$store$state$co3 = _this$$store$state$co3.clip) === null || _this$$store$state$co3 === void 0 ? void 0 : _this$$store$state$co3.ItemCode) || "";
    const nextCode = (clip === null || clip === void 0 ? void 0 : clip.ItemCode) || "";
    if (currentCode === nextCode) return;
    this.$store.commit("configurator/setClip", clip);
  }
  normalizeModelCode(value) {
    return String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "").replace(/CLIP/g, "").replace(/PL/g, "");
  }
  resolveClipForCurrentFrontale() {
    var _this$$store$state$co4;
    if (this.correspondingClip) return this.correspondingClip;
    if (!this.allClips.length) return null;
    const frontModelRaw = ((_this$$store$state$co4 = this.$store.state.configurator) === null || _this$$store$state$co4 === void 0 || (_this$$store$state$co4 = _this$$store$state$co4.frontale) === null || _this$$store$state$co4 === void 0 ? void 0 : _this$$store$state$co4.U_THE_MODELLO) || "";
    const frontModel = this.normalizeModelCode(frontModelRaw);
    if (!frontModel) {
      return this.allClips.length === 1 ? this.allClips[0] : null;
    }
    const matched = this.allClips.find(clip => {
      const clipModel = this.normalizeModelCode((clip === null || clip === void 0 ? void 0 : clip.U_THE_MODELLO) || "");
      if (!clipModel) return false;
      return clipModel.includes(frontModel) || frontModel.includes(clipModel);
    });
    if (matched) return matched;
    return this.allClips.length === 1 ? this.allClips[0] : null;
  }
  selectedClipIndex(lens) {
    return this.selectedClips.findIndex(selected => selected.ItemCode === lens.ItemCode);
  }
  setNumberOfClips(value) {
    this.$store.commit("configurator/setNumberOfClips", value);
    this.syncClipStateWithSelection();
  }
  setClipToVisualize(index) {
    this.clipToVisualize = index;
    this.setClipLensToVisualize();
  }
  setClipLensToVisualize() {
    if (this.clipToVisualize <= 0) {
      this.$store.commit("configurator/setLenteClipToVisualize", null);
      this.$store.commit("configurator/setShowClip", false);
      return;
    }
    const selected = this.selectedClips[this.clipToVisualize - 1] || null;
    this.$store.commit("configurator/setLenteClipToVisualize", selected);
    this.$store.commit("configurator/setShowClip", selected != null);
  }
  toggleClipLens(lens) {
    if (this.numberOfClips <= 0) {
      this.setNumberOfClips(1);
    }
    this.syncClipStateWithSelection();
    const existingIndex = this.selectedClipIndex(lens);
    if (existingIndex !== -1) {
      this.$store.commit("configurator/removeClipLensesModel", lens);
      if (this.clipToVisualize > this.selectedClips.length - 1) {
        this.clipToVisualize = Math.max(0, this.selectedClips.length - 1);
      }
      this.setClipLensToVisualize();
      return;
    }
    if (this.selectedClips.length < this.numberOfClips) {
      this.$store.commit("configurator/addClipLensesModel", lens);
      this.clipToVisualize = this.selectedClips.length;
      this.setClipLensToVisualize();
      return;
    }
    if (this.selectedClips.length > 0) {
      this.$store.commit("configurator/replaceClipLensesModel", {
        lens,
        index: this.selectedClips.length - 1
      });
      this.clipToVisualize = this.selectedClips.length;
      this.setClipLensToVisualize();
    }
  }
};
__decorate([Prop({
  default: false
})], Clip.prototype, "darkTheme", void 0);
__decorate([Watch("numberOfClips")], Clip.prototype, "onNumberOfClipsChanged", null);
__decorate([Watch("frontale")], Clip.prototype, "onFrontaleChanged", null);
__decorate([Watch("correspondingClip")], Clip.prototype, "onCorrespondingClipChanged", null);
Clip = __decorate([Component], Clip);
export default Clip;